// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"StickyFooter_stickyFooter__GbQPU"};